<template>
  <section class="our-stack-section pt-120 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.header.title }}</h2>
            <p>{{ content.header.description }}</p>
          </div>
        </div>
      </div>

      <div class="stack-categories">
        <div class="stack-category" v-for="(category, index) in content.categories" :key="index">
          <h3>{{ category.name }}</h3>
          <div class="tech-tags">
            <span class="tech-tag" v-for="(tech, techIndex) in category.technologies" :key="techIndex">
              {{ tech }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TechItsOurStackComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Our Stack Section */
.our-stack-section {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  background: linear-gradient(145deg, #071b24, #00061a);
  color: #fff;
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
}

.section-title p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

.stack-categories {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 50px;
}

.stack-category {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(246, 236, 79, 0.2);
  border-radius: 15px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
}

.stack-category:hover {
  background: rgba(246, 236, 79, 0.1);
  border-color: #f6ec4f;
  transform: translateY(-5px);
}

.stack-category h3 {
  font-size: 24px;
  font-weight: 600;
  color: #f6ec4f;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.tech-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.tech-tag {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(246, 236, 79, 0.3);
  transition: all 0.3s ease;
}

.tech-tag:hover {
  background: #f6ec4f;
  color: #00061a;
  border-color: #f6ec4f;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .our-stack-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .our-stack-section {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 32px;
  }
  
  .stack-categories {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .stack-category {
    padding: 25px;
  }
  
  .stack-category h3 {
    font-size: 20px;
  }
  
  .tech-tag {
    font-size: 12px;
    padding: 6px 12px;
  }
}

@media only screen and (max-width: 399px) {
  .our-stack-section {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
}
</style>
